import { useEffect, useState } from 'react';

import { SEARCH_DEBOUNCE_MS } from '../../../core/constants/forms';
import { useCombobox } from '../../../common/hooks/use-combobox';
import AnimalSearch from '../../animals/forms/animal-search';
import { useProjectedCrossSearch } from '../../projected-crosses/contexts/search';

// Pickers (typeahead) del formulario de venta. Reutilizan las clases `.search`
// de clients/styles/search.css (ya en el bundle vía ClientFarmSearch).

// Cría real: animal existente (envuelve el buscador genérico de animales).
export function CalfSearch({ onSelect, disabled }) {
    return <AnimalSearch onSelect={onSelect} disabled={disabled} placeholder="Buscar cría por nombre, número o registro…" />;
}

// Cruce proyecto: plantilla donadora × toro (GET /admin/projected-crosses?q=).
export function CrossSearch({ onSelect, disabled }) {
    const [text, setText] = useState('');
    const [debounced, setDebounced] = useState('');
    useEffect(() => {
        const t = setTimeout(() => setDebounced(text), SEARCH_DEBOUNCE_MS);
        return () => clearTimeout(t);
    }, [text]);

    const term = debounced.trim();
    const { data, isFetching, error } = useProjectedCrossSearch(debounced);
    const items = data?.items ?? [];

    const choose = (c) => { setText(c.code || c.name || `#${c.id}`); onSelect?.(c); };
    const cb = useCombobox({ items, onChoose: choose });

    return (
        <div className="search">
            <input
                type="text" className="search__input" value={text}
                placeholder="Buscar cruce por código o nombre…" disabled={disabled}
                role="combobox"
                aria-autocomplete="list"
                aria-expanded={cb.open}
                aria-controls={cb.listId}
                aria-activedescendant={cb.activeId}
                onChange={(e) => { setText(e.target.value); cb.setOpen(true); }}
                onFocus={cb.onFocus} onBlur={cb.onBlur}
                onKeyDown={cb.onKeyDown}
            />
            {cb.open && (
                <div className="search__panel" role="listbox" id={cb.listId}>
                    {term.length < 2 ? (
                        <p className="search__hint">Escribí al menos 2 caracteres.</p>
                    ) : error ? (
                        <p className="search__hint">{error.status === 403 ? 'Sin permiso para buscar cruces.' : 'No se pudo buscar.'}</p>
                    ) : !items.length ? (
                        <p className="search__hint">{isFetching ? 'Buscando…' : 'Sin resultados.'}</p>
                    ) : (
                        <div className="search__group">
                            {items.map((c, i) => (
                                <button
                                    key={c.id}
                                    type="button"
                                    id={cb.optionId(i)}
                                    role="option"
                                    aria-selected={cb.activeIndex === i}
                                    className={`search__item ${cb.activeIndex === i ? 'search__item--active' : ''}`}
                                    onMouseDown={cb.onOptionMouseDown(c)}
                                    onMouseEnter={() => cb.setActive(i)}
                                >
                                    <span className="search__item-body">
                                        <span className="search__item-name">{c.code || c.name || `#${c.id}`}</span>
                                        <span className="search__item-sub">
                                            {`${c.donor?.name || '—'} × ${c.sire?.name || '—'}`}{c.capacity != null ? ` · cupo ${c.capacity}` : ''}
                                        </span>
                                    </span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
